export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/2cb37da391587709fd85749e116baa74.svg";